import { BaseIcon, BaseIconProps } from './BaseIcon';

export const FileTextGradient: React.FC<BaseIconProps> = (props) => (
  <BaseIcon gradientId="fileTextGrad" {...props}>
    <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z" stroke="url(#fileTextGrad)" />
    <path d="M14 2v6h6M16 13H8M16 17H8M10 9H8" stroke="url(#fileTextGrad)" />
  </BaseIcon>
);
